module.exports = __webpack_public_path__ + "img/img-part-3-chick-1.e23e8733.png";